import { Button, Form, Row, Skeleton, Space, Table, Typography } from 'antd';

import { EmptyComponentWithDataTestId } from '@app/components';
import {
  PREFIX,
  RIGHTS_CLIENT_SERVICES,
  RIGHTS_IS_ATTACH,
} from '@app/constants';
import { useAccessRights, useWindowSize } from '@app/hooks';

import { useClientsServiceEmployees } from '@pages/Clients/EditClientService/components/ClientsServiceEmployees/hooks/useServiceEmployees';

import '@pages/Clients/EditClientService/components/ClientsServiceEmployees/styles/ClientsServiceEmployees.desktop.scss';

const { Text } = Typography;

export const ClientsServiceEmployees = () => {
  const {
    columns,
    data,
    allEmployees,
    loader,
    form,
    sendDataToDb,
    addEmployee,
    unselectedEmployees,
  } = useClientsServiceEmployees();
  const { hasUserRight: rightToChangeEmployees } = useAccessRights(
    RIGHTS_CLIENT_SERVICES,
    RIGHTS_IS_ATTACH
  );

  const { innerWidth } = useWindowSize();
  const pageContentWidth =
    document.querySelector('.ant-tabs-nav-wrap')?.getBoundingClientRect()
      .width || null;

  if (!allEmployees && !data) {
    return <Skeleton active />;
  }

  return (
    <div className={`${PREFIX}clients-service-employees`}>
      <Space direction="vertical">
        <Text data-testid="hint">
          Добавьте исполнителей, которые выполняют услугу, чтобы клиенты могли к
          ним записаться через администратора.
        </Text>
        <Form
          className="service-employees__form"
          form={form}
          name="client-service-employees"
          initialValues={{ remember: true }}
          onFinish={sendDataToDb}
        >
          <Space size="small" direction="vertical" style={{ width: '100%' }}>
            <Table
              locale={{
                emptyText: <EmptyComponentWithDataTestId />,
              }}
              className="service-employees__table"
              columns={columns}
              dataSource={data}
              pagination={false}
              loading={loader}
              style={{
                width: innerWidth < 800 ? `${pageContentWidth}px` : 'auto',
              }}
              rowKey={({ Key }) => Key}
            />
            <Row justify={'start'}>
              {unselectedEmployees.length > 0 && rightToChangeEmployees && (
                <Button
                  type="primary"
                  style={{ marginBottom: 16 }}
                  size="small"
                  onClick={addEmployee}
                  data-testid="add-executor"
                >
                  Добавить исполнителя
                </Button>
              )}
            </Row>
          </Space>
          {rightToChangeEmployees && (
            <Row justify="start">
              <Form.Item>
                <Button
                  htmlType="submit"
                  size="large"
                  type="primary"
                  style={{ marginBottom: 16 }}
                  data-testid="save"
                >
                  Сохранить
                </Button>
              </Form.Item>
            </Row>
          )}
        </Form>
      </Space>
    </div>
  );
};
